import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MediaOutline } from '@bonusly/design-system';

import { useFileSelector } from '../../hooks/use-file-selector';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { DecorationButton } from './decoration-button';

interface AttachmentButtonProps {
	decorationVariant?: 'default' | 'list-item';
}

export const AttachmentButton: FC<AttachmentButtonProps> = ({ decorationVariant = 'default' }) => {
	const isEnabled = useIsEnabled('attachment');
	const openFileSelector = useFileSelector({
		allowedExtensions: ['avi', 'jpg', 'jpeg', 'mov', 'mp4', 'png', 'gif', 'webm', 'wmv'],
	});
	const { t } = useTranslation('action_input');

	if (!isEnabled) {
		return null;
	}

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.currentTarget.blur();
		openFileSelector();
	};

	return (
		<DecorationButton label={t('decorations.upload_attachment_tooltip')} onClick={handleClick} decorationVariant={decorationVariant}>
			<MediaOutline />
		</DecorationButton>
	);
};
